import { Loader } from 'kiswe-ui'

export class FanRoomScheduleTimeRange {
  // TODO: Will we need a "processed" prop to keep track of which entries have been already processed?
  enabled: boolean
  endTime: Date
  startTime: Date

  constructor (data: unknown) {
    this.enabled = Loader.loadBoolean(data, 'enabled')
    this.endTime = Loader.loadDate(data, 'endTime')
    this.startTime = Loader.loadDate(data, 'startTime')
  }
}
